export const DEFAULT_ERROR = 'Ошибка соединения с сервером';

export default {
};
